<template>
   <el-dialog title="新增图层" :visible.sync="dialogVisible" width="30%" append-to-body :close-on-click-modal="false">
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="节点名称">
        <el-input v-model="form.name" size="small" :spellcheck ="false" @focus="errorMsg= ''"></el-input>
      </el-form-item>
      <el-form-item label="图层地址">
        <el-input v-model="form.url" size="small" :spellcheck ="false" @focus="errorMsg= ''"></el-input>
      </el-form-item>
      <el-form-item label="图层名称">
        <el-input v-model="form.layer" size="small" :spellcheck ="false" @focus="errorMsg= ''"></el-input>
      </el-form-item>
      <el-form-item label="服务类型:">
        <el-select v-model="form.photoType" class="m-2" placeholder="请选择服务类型" size="small" style="width:100%">
          <el-option key="0" label="WMS" value="0" />
          <el-option key="1" label="WMTS" value="1" />
          <el-option key="2" label=" 3dtiles Service" value="2" />
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="errorMsg" class="warnning-text" style="margin-left: 20px;">{{ errorMsg }}</div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </template>
   </el-dialog>
</template>

<script>
export default {
  name: 'AddNewLayerNodeDialog',

  data() {
    return {
      dialogVisible:false,
      form:{},
      rules:{
        name:{required: true, message: '请输入节点名称'},
        url:{required: true, message: '请输入图层地址'},
        layer:{required: true, message: '请输入图层名称'}

      },
      errorMsg:'',
    };
  },

  mounted() {
    
  },

  methods: {
    handleConfirm(){
      if(this.validate(this.form)){
        this.close()
        const {parent,...props} = this.form
        parent.children.push(props)
     }
    },
    open(data){
      this.dialogVisible=true
      this.errorMsg= ''
      this.form={
        name : '新建图层名称',
        url:'',
        layer:'',
        photoType:'0',
        parent:data
      }
    },
    close(){
      this.dialogVisible=false
    },
    validate(form){
      let msg = ''
      if (!form.name) {
        msg= '请输入图层名称'
      }else{
        form.name = this.formatStr(form.name)
      }

      if (!form.url) {
        msg='请输入图层地址'
      }else{
        form.url = this.formatStr(form.url)
      }


      if (!form.layer) {
        msg='请输入图层名称'
      }else{
        form.layer = this.formatStr(form.layer)
      }

      if (!form.photoType) {
        msg='请输入服务类型'
      }
    
      this.errorMsg= msg
      return !this.errorMsg
    },
    formatStr(str){
      return str.trim()
    }
  },
};
</script>